import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  NoChildren: {
    position: "absolute",
    top: "50%",
    width: "100%",
    color: "#d8d8d8",
    fontWeight: 600,
    textAlign: "center"
  },
  List: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row"
  },
  Container: {
    display: "flex",
    flex: "0 0 auto",
    justifyContent: "flex-start",
    flexDirection: "column",
    margin: "8px",
    backgroundColor: "#d8d8d8",
    padding: "15px",
    borderRadius: "5px",
    // Constrain both width AND height so a vertical portrait image does not
    // blow up the container and push sibling elements (e.g. action buttons)
    // out of the modal viewport. objectFit: contain preserves the aspect ratio.
    "& img": {
      maxWidth: "150px",
      maxHeight: "150px",
      objectFit: "contain",
      display: "block"
    }
  },
  DeleteButton: {
    textAlign: "right",
    marginBottom: "15px"
  },
  DeleteIcon: {
    fill: "#6d6d6d",
    cursor: "pointer"
  }
});

export default withStyles(styles);
